import React from 'react';
import properties from '../../constants/Properties';
import Draggable from 'react-draggable';
import { changeShapeFillColor, changeShapeStrokeColor, changeTextProperties, updateCurrentSlideThumbnail } from '../../actions/CurrentSlideActions';
import modeConstants from '../../constants/ModeConstants';
import mouseUtils from '../../components/utils/MouseUtils';
import saveManager from '../utils/SaveManager';
import { refreshVideoEditor } from '../../actions/MenuActions';
import audioEditorUtils from '../audioEditor/utils/AudioEditorUtils';
import locales from '../../locales/LocalesManager';

export const ColorPicker = React.createClass({
    getInitialState() {
        const gradientAreaWidth = this.props.accordionWidth - 3 * properties.STYLING_LEFT_GAP - properties.RAINBOW_WIDTH;
        var top = properties.RAINBOW_HEIGHT / 2 - properties.COLOR_GRADIENT_SELECTOR_SIZE / 2 - properties.COLOR_GRADIENT_SELECTOR_STROKE_WIDTH / 2;
        var left = gradientAreaWidth / 2 - properties.COLOR_GRADIENT_SELECTOR_SIZE / 2 - properties.COLOR_GRADIENT_SELECTOR_STROKE_WIDTH / 2;

        return {
            isThumbOver: false,
            gradientTopStartPosition: top,
            gradientTopCurrentPosition: top,
            gradientLeftStartPosition: left,
            gradientLeftCurrentPosition: left
        };
    },
    onThumbMouseIn () {
        this.setState({
            isThumbOver: true
        });
    },
    onThumbMouseOut () {
        this.setState({
            isThumbOver: false
        });
    },
    onKeyDownRigthRainbow(e) {
        var delta = 2;

        if (e.keyCode == 38) { // Up Key
            this.onSelectorStart();

            setTimeout(function() {
                this.onSelectorDrag(undefined, undefined, - delta);

                setTimeout(function() {
                    this.onSelectorStopped();
                }.bind(this), 10);
            }.bind(this), 10);

        } else
        if (e.keyCode == 40) { // Down Key
            this.onSelectorStart();

            setTimeout(function() {
                this.onSelectorDrag(undefined, undefined, delta);

                setTimeout(function() {
                    this.onSelectorStopped();
                }.bind(this), 10);
            }.bind(this), 10);
        }
    },
    componentDidMount() {
        this.refs.rainbow.addEventListener('mousedown', this.onTrackMouseDown);
        this.refs.gradientAreaDiv.addEventListener('mousedown', this.onGradientAreaClick);
        this.refs.gradientAreaDiv.addEventListener('touchstart', this.onGradientAreaClick);

        this.drawRainbow();
        this.drawGradientArea();
        this.drawColorGradientSelector();
    },
    drawRainbow () {
        var canvas = this.refs.rainbow;
        canvas.width = properties.RAINBOW_WIDTH;
        canvas.height = properties.RAINBOW_HEIGHT;
        var ctx = canvas.getContext('2d');
        var objGradient = ctx.createLinearGradient(0, 0, 0, canvas.height);

        objGradient.addColorStop(0, 'red');
        objGradient.addColorStop(1 / 6, 'orange');
        objGradient.addColorStop(2 / 6, 'yellow');
        objGradient.addColorStop(3 / 6, 'green');
        objGradient.addColorStop(4 / 6, 'blue');
        objGradient.addColorStop(5 / 6, 'Indigo');
        objGradient.addColorStop(1, 'Violet');

        ctx.fillStyle = objGradient;
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.fill();
    },
    drawColorGradientSelector () {
        var canvas = this.refs.colorGradientSelector;
        canvas.width = canvas.height = properties.COLOR_GRADIENT_SELECTOR_SIZE + properties.COLOR_GRADIENT_SELECTOR_STROKE_WIDTH;
        var ctx = canvas.getContext('2d');
        var centerX = canvas.width / 2;
        var centerY = canvas.height / 2;
        var radius = properties.COLOR_GRADIENT_SELECTOR_SIZE / 2;

        ctx.beginPath();

        ctx.arc(centerX, centerY, radius, 0, 2 * Math.PI, false);
        ctx.fillStyle = 'white';
        ctx.fill();

        ctx.lineWidth = properties.COLOR_GRADIENT_SELECTOR_STROKE_WIDTH;
        ctx.strokeStyle = 'black';
        ctx.stroke();

        ctx.closePath();

        ctx.beginPath();

        ctx.arc(centerX, centerY, 4, 0, 2 * Math.PI, false);
        ctx.fillStyle = '#0090E8';
        ctx.fill();

        ctx.closePath();
    },
    drawGradientArea () {
        var canvas = this.refs.colorGradientArea;
        const gardientAreaWidth = this.props.accordionWidth - 3 * properties.STYLING_LEFT_GAP - properties.RAINBOW_WIDTH;
        canvas.width = gardientAreaWidth;
        canvas.height = properties.RAINBOW_HEIGHT;

        this.updateGradient('#048200');
    },
    updateGradient (color) {
        var canvas = this.refs.colorGradientArea;
        var ctx = canvas.getContext('2d');

        const gardientAreaWidth = this.props.accordionWidth - 3 * properties.STYLING_LEFT_GAP - properties.RAINBOW_WIDTH;

        var grd = ctx.createLinearGradient(0, 0, gardientAreaWidth, properties.RAINBOW_HEIGHT);
        grd.addColorStop(0, 'black');
        grd.addColorStop(0.3, 'white');
        grd.addColorStop(0.7, color);
        grd.addColorStop(1, 'black');
        ctx.fillStyle = grd;
        ctx.fillRect(0, 0, gardientAreaWidth, properties.RAINBOW_HEIGHT);
    },
    onSelectorStart() {
        var topString = this.refs.rainbowSelector.style.top;
        var top = Number(topString.substring(0, topString.length - 2));

        this.setState({
            startPosition: top,
            currentPosition: top
        });
    },
    onSelectorDrag(e, coreEvent, movement) {
        var step = coreEvent ? coreEvent.lastY : movement;

        var newPosition = (this.state.startPosition + step);
        const topValue = - properties.RAINBOW_SELECTOR_SIZE / 2 - properties.RAINBOW_SELECTOR_STROKE_WIDTH / 2 + 1;
        const bottomValue = (properties.RAINBOW_HEIGHT - properties.RAINBOW_SELECTOR_SIZE / 2 - properties.RAINBOW_SELECTOR_STROKE_WIDTH / 2 - 1);

        if (newPosition < topValue)
            newPosition = topValue;
        else if (newPosition > bottomValue)
            newPosition = bottomValue;

        this.refs.rainbowSelector.style.top = newPosition + 'px';

        this.setState({
            currentPosition: newPosition
        });
    },
    onSelectorStopped() {
        var color = this.getGradientSelectedColor();
        this.updateGradient(color);
        this.changeColorProperties(color);
    },
    onTrackMouseDown (e) {
        var newPosition = e.offsetY - properties.RAINBOW_SELECTOR_SIZE / 2 - properties.COLOR_GRADIENT_SELECTOR_STROKE_WIDTH / 2;
        this.refs.rainbowSelector.style.top = newPosition + 'px';

        this.setState({
            currentPosition: newPosition
        });

        this.onSelectorStopped();
    },
    getGradientSelectedColor () {
        var canvas = this.refs.rainbow;
        var ctx = canvas.getContext('2d');
        var offset = properties.RAINBOW_SELECTOR_SIZE / 2 + properties.RAINBOW_SELECTOR_STROKE_WIDTH / 2;

        var yPos = this.state.currentPosition + offset;

        if (!yPos || isNaN(yPos) || yPos < 0)
            yPos = 1;
        else
        if (yPos >= canvas.height)
            yPos = canvas.height - 1;

        var RGBcolor = ctx.getImageData(5, yPos, 1, 1).data;
        var hexaColor = this.rgbToHex(RGBcolor[0], RGBcolor[1], RGBcolor[2]);

        return hexaColor;
    },
    transformCssValue (value) {
        var newValue = Number(value.substring(0, value.length - 2));

        return newValue;
    },
    getOffset(e) {
        if (e.offsetX >= 0) {
            return {x: e.offsetX, y: e.offsetY};
        } else {
            var position = mouseUtils.getTouchPosition(e);

            return {x: position.x - (window.innerWidth - this.props.accordionWidth + properties.STYLING_LEFT_GAP), y: position.y - this.props.topPosition};
        }
    },
    onGradientAreaClick (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        var offset = properties.COLOR_GRADIENT_SELECTOR_SIZE / 2 + properties.COLOR_GRADIENT_SELECTOR_STROKE_WIDTH / 2;
        const offsetVal = this.getOffset(e);

        var x = offsetVal.x - offset;
        var y = offsetVal.y - offset;

        if (e.target == this.refs.colorGradientSelectorButton || e.target == this.refs.colorGradientSelector) {
            x = x + this.transformCssValue(this.refs.colorGradientSelectorButton.style.left);
            y = y + this.transformCssValue(this.refs.colorGradientSelectorButton.style.top);
        }

        this.refs.colorGradientSelectorButton.style.left = x + 'px';
        this.refs.colorGradientSelectorButton.style.top = y + 'px';

        this.setState({
            gradientTopStartPosition: y,
            gradientTopCurrentPosition: y,
            gradientLeftStartPosition: x,
            gradientLeftCurrentPosition: x
        });
    },
    onGradientSelectorDrag (e, coreEvent) {
        const newTopPosition = (this.state.gradientTopStartPosition +  coreEvent.lastY);
        const newLeftPosition = (this.state.gradientLeftStartPosition +  coreEvent.lastX);
        const offset = 1;

        const topValue = - properties.COLOR_GRADIENT_SELECTOR_SIZE / 2 - properties.COLOR_GRADIENT_SELECTOR_STROKE_WIDTH / 2 + offset;
        const bottomValue = (properties.RAINBOW_HEIGHT - properties.COLOR_GRADIENT_SELECTOR_SIZE / 2 - properties.COLOR_GRADIENT_SELECTOR_STROKE_WIDTH / 2 - offset);

        const leftValue = - properties.COLOR_GRADIENT_SELECTOR_SIZE / 2 - properties.COLOR_GRADIENT_SELECTOR_STROKE_WIDTH / 2 + offset;
        const gardientAreaWidth = this.props.accordionWidth - 3 * properties.STYLING_LEFT_GAP - properties.RAINBOW_WIDTH;
        const rightValue = (gardientAreaWidth - properties.COLOR_GRADIENT_SELECTOR_SIZE / 2 - properties.COLOR_GRADIENT_SELECTOR_STROKE_WIDTH / 2 - offset);

        if (newTopPosition >= topValue && newTopPosition <= bottomValue) {
            this.refs.colorGradientSelectorButton.style.top = newTopPosition + 'px';
            this.setState({
                gradientTopCurrentPosition: newTopPosition
            });
        }

        if (newLeftPosition >= leftValue && newLeftPosition <= rightValue) {
            this.refs.colorGradientSelectorButton.style.left = newLeftPosition + 'px';
            this.setState({
                gradientLeftCurrentPosition: newLeftPosition
            });
        }
    },
    onGradientSelectorStopped () {
        var color = this.getSelectedColor();
        this.changeColorProperties(color);
    },
    onKeyDownOnCanvas(e) {
        var step = 1;
        var xOffset = 0;
        var yOffset = 0;

        switch (true) {
            case (e.keyCode == 37) : { // LEFT
                xOffset = - step;
                break;
            }
            case (e.keyCode == 38) : { // UP
                yOffset = - step;
                break;
            }
            case (e.keyCode == 39) : { // RIGHT
                xOffset = step;
                break;
            }
            case (e.keyCode == 40) : { // DOWN
                yOffset = step;
                break;
            }
        }

        var newTopPosition = (this.state.gradientTopStartPosition +  yOffset);
        var newLeftPosition = (this.state.gradientLeftStartPosition +  xOffset);

        const offset = 1;
        const topValue = - properties.COLOR_GRADIENT_SELECTOR_SIZE / 2 - properties.COLOR_GRADIENT_SELECTOR_STROKE_WIDTH / 2 + offset;
        const bottomValue = (properties.RAINBOW_HEIGHT - properties.COLOR_GRADIENT_SELECTOR_SIZE / 2 - properties.COLOR_GRADIENT_SELECTOR_STROKE_WIDTH / 2 - offset);
        const leftValue = - properties.COLOR_GRADIENT_SELECTOR_SIZE / 2 - properties.COLOR_GRADIENT_SELECTOR_STROKE_WIDTH / 2 + offset;
        const gardientAreaWidth = this.props.accordionWidth - 3 * properties.STYLING_LEFT_GAP - properties.RAINBOW_WIDTH;
        const rightValue = (gardientAreaWidth - properties.COLOR_GRADIENT_SELECTOR_SIZE / 2 - properties.COLOR_GRADIENT_SELECTOR_STROKE_WIDTH / 2 - offset);

        if (newTopPosition < topValue)
            newTopPosition = topValue;

        if (newTopPosition > bottomValue)
            newTopPosition = bottomValue;

        if (newLeftPosition < leftValue)
            newLeftPosition = leftValue;

        if (newLeftPosition > rightValue)
            newLeftPosition = rightValue;

        this.refs.colorGradientSelectorButton.style.left = newLeftPosition + 'px';
        this.refs.colorGradientSelectorButton.style.top = newTopPosition + 'px';

        this.setState({
            gradientTopStartPosition: newTopPosition,
            gradientTopCurrentPosition: newTopPosition,
            gradientLeftStartPosition: newLeftPosition,
            gradientLeftCurrentPosition: newLeftPosition
        });

        setTimeout(function() {
            var color = this.getSelectedColor();
            this.changeColorProperties(color);
        }.bind(this), 20);
    },
    getSelectedColor () {
        var canvas = this.refs.colorGradientArea;
        var ctx = canvas.getContext('2d');
        var offset = properties.COLOR_GRADIENT_SELECTOR_SIZE / 2 + properties.COLOR_GRADIENT_SELECTOR_STROKE_WIDTH / 2;

        var xPosition = this.state.gradientLeftCurrentPosition + offset;
        var yPosition = this.state.gradientTopCurrentPosition + offset;

        if (isNaN(xPosition))
            xPosition = canvas.width / 2;
        else if (xPosition < 0)
            xPosition = 1;
        else if (xPosition >= canvas.width)
            xPosition = canvas.width - 1;

        if (isNaN(yPosition))
            yPosition = canvas.height / 2;
        else if (yPosition < 0)
            yPosition = 1;
        else if (yPosition >= canvas.height)
            yPosition = canvas.height - 1;

        var imageData = ctx.getImageData(xPosition, yPosition, 1, 1);
        var RGBcolor;

        if (imageData == undefined)
            return '#ffffff';
        else {
            RGBcolor = imageData.data;

            var hexaColor = this.rgbToHex(RGBcolor[0], RGBcolor[1], RGBcolor[2]);

            return hexaColor;
        }
    },
    componentToHex(c) {
        var hex = c.toString(16);
        return hex.length == 1 ? '0' + hex : hex;
    },
    rgbToHex(r, g, b) {
        return '#' + this.componentToHex(r) + this.componentToHex(g) + this.componentToHex(b);
    },
    changeColorProperties (color) {
        if (this.props.executeCommand) {
            this.props.executeCommand(15, color)
            return;
        }

        var shapeModel = this.props.shapeModel;

        if (!shapeModel)
            return;

        if (this.props.type == 'textProperties') {
            this.props.dispatch(changeTextProperties(shapeModel, 'fontColor', color));
        } else {
            if (this.props.tab == modeConstants.LINE_STYLE) {
                if (shapeModel.stroke != color)
                    this.props.dispatch(changeShapeStrokeColor(shapeModel, color));
            }
            else {
                if (shapeModel.fill != color) {
                    this.props.dispatch(changeShapeFillColor(shapeModel, color));
                    this.props.dispatch(refreshVideoEditor(Math.random()));
                }
            }
        }

        audioEditorUtils.addActionToHistory();
        saveManager.isContentChanged(true);

        this.updateThumbnail();
    },
    updateThumbnail() {
        this.props.dispatch(updateCurrentSlideThumbnail(true));
    },
    render() {
        const colorPickerStyle = {
            position: 'absolute',
            top: this.props.topPosition,
            left: 0,
            width: this.props.accordionWidth,
            height: properties.RAINBOW_HEIGHT
        };

        const gradientAreaWidth = this.props.accordionWidth - 3 * properties.STYLING_LEFT_GAP - properties.RAINBOW_WIDTH;

        const colorGradientStyle = {
            position: 'absolute',
            top: 0,
            left: properties.STYLING_LEFT_GAP,
            width: gradientAreaWidth,
            height: properties.RAINBOW_HEIGHT
        };

        const colorGradientAreaStyle = {
            position: 'absolute',
            top: 0,
            left: 0,
            width: gradientAreaWidth,
            height: properties.RAINBOW_HEIGHT
        };

        const colorGradientSelectorButtonStyle = {
            position: 'absolute',
            top: properties.RAINBOW_HEIGHT / 2 - properties.COLOR_GRADIENT_SELECTOR_SIZE / 2 - properties.COLOR_GRADIENT_SELECTOR_STROKE_WIDTH / 2,
            left: gradientAreaWidth / 2 - properties.COLOR_GRADIENT_SELECTOR_SIZE / 2 - properties.COLOR_GRADIENT_SELECTOR_STROKE_WIDTH / 2,
            width: properties.COLOR_GRADIENT_SELECTOR_SIZE + properties.COLOR_GRADIENT_SELECTOR_STROKE_WIDTH,
            height: properties.COLOR_GRADIENT_SELECTOR_SIZE + properties.COLOR_GRADIENT_SELECTOR_STROKE_WIDTH,
            background: 'none',
            border: 'none'
        };

        const colorGradientSelectorStyle = {
            position: 'absolute',
            top: properties.COLOR_GRADIENT_SELECTOR_STROKE_WIDTH / 2,
            left: properties.COLOR_GRADIENT_SELECTOR_STROKE_WIDTH / 2,
            width: colorGradientSelectorButtonStyle.width - properties.COLOR_GRADIENT_SELECTOR_STROKE_WIDTH,
            height: colorGradientSelectorButtonStyle.height - properties.COLOR_GRADIENT_SELECTOR_STROKE_WIDTH
        };

        const rainbowStyle = {
            position: 'absolute',
            top: 0,
            left: this.props.accordionWidth - properties.STYLING_LEFT_GAP - properties.RAINBOW_WIDTH,
            width: properties.RAINBOW_WIDTH,
            height: properties.RAINBOW_HEIGHT
        };

        const rainbowImgStyle = {
            position: 'absolute',
            top: 0,
            left: 0,
            width: properties.RAINBOW_WIDTH,
            height: properties.RAINBOW_HEIGHT
        };

        const thumbBorderSize = 2;
        const thumbSize = properties.RAINBOW_SELECTOR_SIZE - thumbBorderSize;
        var thumbBorderColor = 'black';

        if (this.state.isThumbOver == true)
            thumbBorderColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;

        const rainbowSelectorStyle = {
            position: 'absolute',
            top: properties.RAINBOW_HEIGHT / 2 - thumbSize / 2,
            left: - thumbSize / 2 + properties.RAINBOW_WIDTH / 2 - thumbBorderSize,
            width: thumbSize,
            height: thumbSize,
            background: 'white',
            borderStyle: 'solid',
            borderColor: thumbBorderColor,
            borderWidth: 2,
            borderRadius: 50,
            cursor: 'default',
            margin: 0,
            padding: 0,
            fontSize: 'initial',
            boxSizing: 'initial'
        };

        return (
            <div style={colorPickerStyle}>
                <Draggable axis="none" position={{x:0, y:0}} onDrag={this.onGradientSelectorDrag} onStop={this.onGradientSelectorStopped}>
                    <div ref='gradientAreaDiv' style={colorGradientStyle}>
                        <canvas ref="colorGradientArea" style={colorGradientAreaStyle}/>

                        <button aria-label={locales.getCaption('colorPickerThumb', 'other')} className='sliderThumb' style={colorGradientSelectorButtonStyle} onKeyDown={this.onKeyDownOnCanvas} ref="colorGradientSelectorButton">
                            <canvas ref="colorGradientSelector" style={colorGradientSelectorStyle}/>
                        </button>
                    </div>
                </Draggable>
                <div style={rainbowStyle}>
                    <canvas ref="rainbow" style={rainbowImgStyle}/>
                    <Draggable axis="none" position={{x:0, y:0}} onStart={this.onSelectorStart} onDrag={this.onSelectorDrag} onStop={this.onSelectorStopped}>
                        <button id={this.props.id} aria-label={locales.getCaption('colorPickerThumb', 'other')} ref='rainbowSelector' className='sliderThumb' style={rainbowSelectorStyle} onKeyDown={this.onKeyDownRigthRainbow} onMouseOver={this.onThumbMouseIn} onMouseOut={this.onThumbMouseOut}/>
                    </Draggable>
                </div>
            </div>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./src/components/menus/ColorPicker.js
 **/